import { createAPI } from '@common'
export default {
  // 获取稿签范围初始化列表
  getLabelRange: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0hfuMbcfmSbohf', 'GET', config),
  // 获取分类树根分类
  getCatRoot: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0spput', 'GET', config),
  // add获取见报版面范围初始化列表
  getPaperLayoutRange: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0hfuQbqfsMbzpvuSbohf', 'GET', config),
  //统一公共管理-稿签名称查重
  checkLabelName: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0difdlMbcfmObnf', 'POST', config),
  //统一公共管理-稿签列码查重
  checkLabelCode: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0difdlMbcfmDpef', 'POST', config),
  // 统一公共管理-保存稿签
  saveLable: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0tbwf', 'POST', config),
  //统一公共管理-修改稿签属性
  updateLabelValue: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0vqebufMbcfmWbmvf', 'POST', config),
  //统一公共管理-稿签详情
  getLabelDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0mbcfm', 'GET', config),
  //统一公共管理-稿签排序
  postSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0tpsu', 'POST', config),
  //音频编目设置
  updateLabelValueAudioCata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0vqebufMbcfmWbmvf', 'POST', config),
  postSortAudioCata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0tpsu', 'POST', config),
  checkLabelNameAudioCata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0difdlMbcfmObnf', 'POST', config),
  saveLableAudioCata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0tbwf', 'POST', config),
  getLabelDetailAudioCata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0mbcfm', 'GET', config),
  //视频编目设置
  updateLabelValueVideoCata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0vqebufMbcfmWbmvf', 'POST', config),
  postSortVideoCata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0tpsu', 'POST', config),
  checkLabelNameVideoCata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0difdlMbcfmObnf', 'POST', config),
  saveLableVideoCata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0tbwf', 'POST', config),
  getLabelDetailVideoCata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0mbcfm', 'GET', config),
  // 获取选题策划稿签范围初始化列表
  getTopicLabelRange: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0hfuOfxtQmboSbohf', 'GET', config),
  // 部门库人员列表排序
  postUserfolderSort: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0tpsu', 'POST', config)
}
